import ImagePlaceholder from './ImagePlaceholder'
export * from './ImagePlaceholder'
export default ImagePlaceholder
